import { render, staticRenderFns } from "./HistoryComments.vue?vue&type=template&id=148c4fac&scoped=true"
import script from "./HistoryComments.vue?vue&type=script&lang=js"
export * from "./HistoryComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c4fac",
  null
  
)

export default component.exports